<template>
  <div v-if="salaryData !==null" class="w-full bg-white pb-16 tab-content mt-6">
    <div class="font-medium text-lg px-4 py-8  flex item-center border-b">
      <zt-icon name="chart-line-arrow-up" class="mr-2 icon-size" />
      <h1>{{ $t('message.selfService.infoEmployee.salaryInfo.salary') }}</h1>
    </div>
    <div class="salary-chart overflow-x-auto" id='salary-chart'/>
  </div>
  <div v-else>
    <div class="w-full md:w-2/3 m-6 py-6">
      <zt-alert color="info" filled :closeIcon="false">
        <template slot="custom-content">
          <div class="flex justify-start items-center">
            <zt-icon name="info-circle-solid" class="text-2xl mr-4"></zt-icon>
            <p>{{ $t('message.selfService.infoEmployee.tab.emptyTab') }}</p>
          </div>
        </template>
      </zt-alert>
    </div>
  </div>
</template>
  
<script>
import * as d3 from 'd3'
import { timeFormatLocale } from 'd3-time-format';
export default {
  name: 'UserSalaryInfo',
  props: {
    salaryData: { type: Object }
  },
  data() {
    return {
      neto: this.salaryData.net,
      gross: this.salaryData.gross
    }
  },
  async mounted() {
    let colorBruto = "#54CAA6";
    let colorNeto = "#2896C8";
    
    let esLocale = timeFormatLocale({
      dateTime: "%A, %e de %B de %Y, %X",
      date: "%d/%m/%Y",
      time: "%H:%M:%S",
      periods: ["AM", "PM"],
      days: ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"],
      shortDays: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
      months: ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"],
      shortMonths: ["ENE", "FEB", "MAR", "ABR", "MAY", "JUN", "JUL", "AGO", "SEP", "OCT", "NOV", "DIC"],
      format: function(date) {
    const shortMonth = this.shortMonths[date.getMonth()];
    const shortYear = date.getFullYear().toString().slice(-2);
    return `${shortMonth} ${shortYear}`;
  }
    });

    let svg = d3.select("#salary-chart").append("svg").attr("width", 700).attr("height", 600); // Aumenta la altura para acomodar la leyenda
    let margin = { top: 20, right: 20, bottom: 100, left: 70 }; // Aumenta el margen inferior para acomodar la leyenda
    let width = +svg.attr("width") - margin.left - margin.right;
    let height = +svg.attr("height") - margin.top - margin.bottom;
    let g = svg.append("g").attr("transform", "translate(" + margin.left + "," + margin.top + ")");

    let x = d3.scaleTime().rangeRound([0, width]);
    let y = d3.scaleLinear().rangeRound([height, 0]);

    let areaBruto = d3.area().x(d => x(new Date(d.year, d.month - 1))).y0(height).y1(d => y(this.gross.find(g => g.month === d.month && g.year === d.year).salary));
    let areaNeto = d3.area().x(d => x(new Date(d.year, d.month - 1))).y0(height).y1(d => y(this.neto.find(n => n.month === d.month && n.year === d.year).salary));
    x.domain(d3.extent(this.neto, d => new Date(d.year, d.month - 1)));
    y.domain([0, d3.max(this.neto.concat(this.gross), d => d.salary)]);

    g.append("path").datum(this.gross).attr("fill", colorBruto).attr("d", areaBruto).attr("id", "pathBruto");
    g.append("path").datum(this.neto).attr("fill", colorNeto).attr("d", areaNeto).attr("id", "pathNeto");

    g.append("g").attr("transform", "translate(0," + height + ")").call(d3.axisBottom(x).ticks(this.gross.length).tickFormat(esLocale.format("%b (%y)")));

    g.append("g").call(d3.axisLeft(y));

    let legend = svg.append("g")
        .attr("font-family", "sans-serif")
        .attr("font-size", 12)
        .attr("text-anchor", "end")
        .attr("transform", "translate(" + (width / 2) + "," + (height + margin.top + 40) + ")") 
        .selectAll("g")
        .data(["Bruto", "Neto"])
        .enter().append("g")
        .attr("transform", (d, i) => "translate(" + i * 100 + ", 0)"); 

      legend.append("circle")
        .attr("cx", 0)
        .attr("cy", 7)
        .attr("r", 6)
        .attr("fill", d => (d === "Bruto" ? colorBruto : colorNeto));

      legend.append("text")
        .attr("x", 35)
        .attr("y", 8)
        .attr("dy", "0.32em")
        .text(d => d);

        
     let tooltip = d3.select("#salary-chart").append("div")
      .attr("class", "tooltip")
      .style("opacity", 0)
      .style("position", "fixed")
      .style("background-color", "#f9f9f9")
      .style("border", "1px solid #ddd")
      .style("border-radius", "5px")
      .style("padding", "8px");

    //tooltip de salario bruto
    d3.select("#pathBruto")
      .on("mouseover", function (event, d) {
        const [x] = d3.pointer(event);
        tooltip.transition()
          .duration(200)
          .style("opacity", .9);

        const index = Math.floor(x / (width / d.length));
        const salario = d[index].salary;
        tooltip.html("Salario bruto: $" + salario)
          .style("left", (event.clientX) + "px")
          .style("top", (event.pageY - 28) + "px");
      })
      .on("mouseout", function (d) {
        tooltip.transition()
          .duration(200)
          .style("opacity", 0);
      });

    // tooltip de salario neto
    d3.select("#pathNeto")
      .on("mouseover", function (event, d) {
        const [x] = d3.pointer(event);
        tooltip.transition()
          .duration(200)
          .style("opacity", .9);

        const index = Math.floor(x / (width / d.length));
        const salario = d[index].salary;
        tooltip.html("Salario neto: $" + salario)
          .style("left", (event.clientX) + "px")
          .style("top", (event.pageY - 28) + "px");

      })
      .on("mouseout", function (d) {
        tooltip.transition()
          .duration(200)
          .style("opacity", 0);
      });
  }
}
</script>
  
<style scoped lang="scss">
.tab-content {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
}
.icon-size{
  font-size: 1.8rem;
}
</style>
  